module.exports = __webpack_public_path__ + "img/contingency.8b73f823.png";